import { formatDate } from '../../../../../../utils/tableFuncs'
import fuelReportExpenseDetailsColumns from './fuelReportExpenseDetailsColumns'
import type { Row } from '@tanstack/react-table'
import type { FuelReportExpenseDetails } from '../../../../../../types'
import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { useSearchParams } from 'react-router-dom'
import { formatNumber } from '../../../utils/formatNumber'
import { formatCurrency } from '../../../utils/formatCurrency'

const formatTransactionDate = (value: string) => {
  if (!value) return ''

  const dateParts = value.split(/[.-]/)
  const normalizedDate = dateParts.length === 3 ? `20${dateParts.reverse().join('-')}T00:00:00` : value
  return formatDate(normalizedDate) || ''
}

type FuelReportExpenseDetailsProps = {
  data: FuelReportExpenseDetails[]
  isLoading?: boolean
}

function FuelReportExpenseDetailsTable({ data, isLoading }: FuelReportExpenseDetailsProps) {
  const columns = fuelReportExpenseDetailsColumns()

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      columnWidths={{
        referenceNo: { width: 190, minWidth: 170, maxWidth: 230 },
        retailStationName: { width: 185, minWidth: 160, maxWidth: 220 },
        amountIncVat: { width: 165, minWidth: 150, maxWidth: 180 },
      }}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} />
      }}
    />
  )
}

export default FuelReportExpenseDetailsTable

function MobileCardContent({ row }: { row: Row<FuelReportExpenseDetails> }) {
  const [searchParams] = useSearchParams()
  const { transactionDate, transactionTime, referenceNo, retailStationName, productDescription, amountIncVat, volume } =
    row.original

  const data = [
    {
      label: 'Dato',
      value: formatTransactionDate(transactionDate),
    },
    {
      label: 'Tidspunkt',
      value: transactionTime?.split(':').slice(0, 2).join(':') || '',
    },
    {
      label: 'Regnr',
      value: searchParams.get('regNo') || '',
    },
    {
      label: 'Kortnr.',
      value: referenceNo || '',
    },
    {
      label: 'Stasjon',
      value: retailStationName || '',
    },
    {
      label: 'Produkt',
      value: productDescription || '',
    },
    {
      label: 'Beløp inkl. mva',
      value: formatCurrency(amountIncVat),
    },
    {
      label: 'Mengde',
      value: formatNumber(volume, { digits: { min: 0, max: 2 } }),
    },
  ]
  const header = `Transaksjon - ${formatTransactionDate(transactionDate)}`
  return <TableMobileCardContent header={header} data={data} />
}
